import React from 'react';
import { Document } from '@contentful/rich-text-types';

import { Text } from '../Text';
import { Box } from '../Box';
import { UnstyledButton } from '../Button';
import RichText from '../RichText';
import CollapsibleContainer from './CollapsibleContainer';

import {
  BoxWithBorder,
  ToggleWrapper,
  ToggleIcon,
  ClickableFlexbox
} from './styles';

import plus from '@/images/plus.svg';

interface Props {
  title: string;
  content?: Document;
  isOpen: boolean;
  onClick?: () => void;
}

export function Collapsible({
  title,
  content,
  isOpen,
  onClick = () => null
}: Props) {
  return (
    <BoxWithBorder
      padding={{
        0: ['collapsibleVert', 0],
        tablet: ['l', 0]
      }}
    >
      <ClickableFlexbox
        justifyContent="space-between"
        alignItems="flex-start"
        onClick={onClick}
      >
        <Text
          as="h3"
          fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
          fontWeight="h3"
        >
          {title}
        </Text>
        <Box
          paddingLeft={{ 0: 's', tablet: 'm' }}
          paddingTop={{ 0: '2xs', tablet: 'xs' }}
        >
          <UnstyledButton onClick={onClick} data-testid="collapsible-btn">
            <ToggleWrapper>
              <ToggleIcon
                src={plus}
                alt={isOpen ? 'Close section' : 'Open section'}
                isOpen={isOpen}
              />
            </ToggleWrapper>
          </UnstyledButton>
        </Box>
      </ClickableFlexbox>
      {isOpen && (
        <CollapsibleContainer>
          <Box paddingTop={{ 0: 'sm' }}>
            {content && (
              <RichText
                data={content}
                bulletColor="green"
                data-testid="collapsible-body-text"
              />
            )}
          </Box>
        </CollapsibleContainer>
      )}
    </BoxWithBorder>
  );
}
